export type UserId = string;

export const USER_TYPES = {
    INSTALLER: 'installer',
    OWNER: 'owner',
    ADMIN: 'admin',
    ANONYMOUS: 'anonymous',
} as const;

export type UserType = (typeof USER_TYPES)[keyof typeof USER_TYPES];

export interface User {
    id: UserId;
    accountType: 'account' | 'subaccount';
    email: string;
    country: string;
    crmId: string;
    crmName: string;
    businessUnit: string;
}

export interface SiteUpdateForm {
    name: string;
}
